<template>
  <div class="news-box" v-if="blockDetailsContent">
    <div class="news-box__tabs">
      <div class="news-box__tabs-headline">
        <div
          v-for="(item, index) in blockDetailsContent"
          :key="index"
          class="news-box__tabs-headline-item"
          @click="changeActiveElem(index)"
          :class="{ active: activeElement === index, 'one-item': blockDetailsContent.length === 1 }"
        >
          <span class="news-box__headline-title">{{ item.title }}</span>
        </div>
      </div>
      <div class="news-box__tabs-content">
        <div
          v-for="(item, index) in blockDetailsContent"
          :key="index"
          class="news-box__tabs-content--item"
        >
          <div
            v-if="index === activeElement"
            :class="[
              'news-box__container',
              { 'full-height': fullBox, 'news-box__home-page': homePage }
            ]"
            @scroll="handleSCroll"
          >
            <div
              v-for="(itemEl, indexEl) in item.items"
              :key="indexEl"
              class="news-box__container-item"
              :class="{
                'last-item-new': indexEl === item.items.length - 1 && index === 0 && item.show_more,
                'last-item-pop': indexEl === item.items.length - 1 && index === 1
              }"
            >
              <span
                :class="[
                  'news-box__container-date',
                  {
                    'active-date':
                      formatDateToTime(itemEl.release_date) > formatDateToTime(checkHour)
                  }
                ]"
                v-if="index === 0"
              >
                {{ formatDateToTime(itemEl.release_date) }}
              </span>
              <span class="news-box__container-bullet" v-else>•</span>
              <app-link
                class="news-box__container-text"
                :to="itemEl.url"
                :path-type="itemEl.type"
                :routing-data="itemEl.routing_data"
              >
                {{ itemEl.title }}
              </app-link>
            </div>
            <div class="news-box__gradient" v-if="!isBottom && !fullBox"></div>
            <a
              v-if="item.show_more"
              :href="item.show_more.url"
              class="news-box__btn-show-more"
              :class="{ visible: fullBox }"
            >
              Zobacz więcej
              <i class="icon-right-open-mini"></i>
            </a>
            <div class="news-box__btn-show-more" v-if="!isDesktop" @click="toggleBox">
              {{ fullBox ? 'Zwiń' : 'Rozwiń' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useSectionsStore } from '@/stores/section'
import { storeToRefs } from 'pinia'
import { useUtils } from '@/composables/useUtils'
import { useBreakpoint } from '@/composables/useBreakpoints'
import AppLink from '@/components/layout/AppLink.vue'

const { formatDateToTime } = useUtils()

const { isDesktop } = useBreakpoint()

const sectionsStore = useSectionsStore()
const { fetchBlockDetails } = sectionsStore
const { blockDetails, pageSettingType } = storeToRefs(sectionsStore)

const isBottom = ref(false)
const activeElement = ref(0)

const blockDetailsContent = computed(() => blockDetails.value[props.id]?.items)
const changeActiveElem = (index) => {
  activeElement.value = index
  isBottom.value = false
}

const homePage = computed(() => pageSettingType.value === 'SG')

const fullBox = ref(false)
const toggleBox = () => {
  fullBox.value = !fullBox.value
}

const checkHour = computed(() => Date.now() - 1000 * 60 * 60)

const handleSCroll = (event) => {
  if (event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight <= 1) {
    isBottom.value = true
  } else isBottom.value = false
}

const props = defineProps({
  id: {
    type: Number,
    default: 0
  }
})

onMounted(() => {
  fetchBlockDetails(props.id)
})
</script>
<style lang="scss">
@import '@/assets/scss/components/boxes/news-box';
</style>
